import { defineStore } from "pinia";

import {
  ACTION_CREATION_TEMPLATE_PUBLISH,
  ACTION_CREATION_TEMPLATE_PUBLISH_AE,
  GETTER_CREATION_DEMAND_GET_PUBLISHED_ID,
  GETTER_CREATION_DEMAND_GET_PUBLISHED_TYPE,
} from "@etab/stores/types";
import { CreationDemandService } from "@core/services";

export const useCreationDemandStore = defineStore("creationDemand", {
  // convert to a function
  state: () => ({
    publishedId: undefined,
    publishedType: undefined,
  }),
  getters: {
    [GETTER_CREATION_DEMAND_GET_PUBLISHED_ID]: (state) => state.publishedId,
    [GETTER_CREATION_DEMAND_GET_PUBLISHED_TYPE]: (state) => state.publishedType,
  },
  actions: {
    async [ACTION_CREATION_TEMPLATE_PUBLISH](templateId) {
      try {
        const id = await CreationDemandService.publish(templateId);
        if (id) {
          this.publishedId = id;
        }
      } catch (error) {
        throw error;
      }
    },
    async [ACTION_CREATION_TEMPLATE_PUBLISH_AE](templateId) {
      try {
        const { id, type } = await CreationDemandService.publishAEDemand(templateId);
        if (id && type) {
          this.publishedId = id;
          this.publishedType = type;
        }
      } catch (error) {
        throw error;
      }
    },
    // easily reset state using `$reset`
    clearCreationDemandStore() {
      this.$reset();
    },
  },
});
